module.exports = __webpack_public_path__ + "img/element-iot-icon-h300.9cd696b4.png";